<template>
    <ul class="tw-list-disc tw-list-outside tw-space-y-2 tw-pl-5">
        <li
            v-for="(question, index) in countryQuestions"
            :key="index"
        >
            {{ question }}
        </li>
    </ul>
</template>

<script>
export default {
    name: "CountryQuestions",
    props: {
        country: {
            type: Object,
            required: true
        },
        countryName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            countryQuestions: []
        };
    },
    mounted() {
        this.loadCountryQuestions();
    },
    methods: {
        loadCountryQuestions() {
            try {
                if (this.country?.mainCountry?.followUpQuestions) {
                    this.countryQuestions = this.country.mainCountry.followUpQuestions.map(q => 
                        q.questionText.replace(/%country%/g, this.countryName)
                    );
                } else {
                    // Fallback to empty array if no follow-up questions available
                    this.countryQuestions = [];
                }
            } catch (error) {
                console.error('Error loading country questions:', error);
                this.countryQuestions = [];
            }
        }
    }
}
</script>

<style scoped>

</style> 